import React from 'react';
import { colors } from '../constants';

import { unselectedStrokeStrongYesOrNoColor } from './icon_helpers';

const RatingStrongYesIcon = ({
  width = 20,
  height = 20,
  unselected = false,
}) => {
  const fillColor = unselected
    ? unselectedStrokeStrongYesOrNoColor
    : colors.mediumGreenhouseGreen;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <path
        fill={fillColor}
        d="M7.195 6.955L9.335.48c.211-.639 1.114-.639 1.325 0l2.14 6.476h6.496c.655 0 .949.82.444 1.236l-5.226 4.307 1.9 6.609c.184.639-.545 1.148-1.082.755l-5.334-3.904-5.335 3.904c-.537.393-1.266-.116-1.082-.755l1.9-6.609L.255 8.191C-.25 7.775.045 6.955.7 6.955h6.496z"
      />
    </svg>
  );
};

export default RatingStrongYesIcon;
